var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { cssClassMap } from '../../../constants/SportCssMap';
import { getMomentLocale } from '../../../shared/momentLocale';
var preMatchHeader = /** @class */ (function (_super) {
    __extends(preMatchHeader, _super);
    function preMatchHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function () {
            localStorage.setItem('backward', 'clicked');
            _this.props.goBack();
        };
        return _this;
    }
    preMatchHeader.prototype.componentDidMount = function () {
        localStorage.setItem('backward', 'clicked');
        localStorage.setItem('lastExpandedLeague', this.props.leagueId);
    };
    preMatchHeader.prototype.render = function () {
        var props = this.props;
        var locale = getMomentLocale(props.languageId);
        var sportCssName = cssClassMap[props.sportId];
        return (_jsx("div", __assign({ className: "backward ".concat(sportCssName) }, { children: _jsxs("div", __assign({ className: 'header' }, { children: [_jsx("div", { className: 'back', onClick: this.onClick }), _jsxs("div", __assign({ className: 'sub' }, { children: [moment(props.date).locale(locale).format('DD-MMM').split('.')[0], " ", _jsx("br", {}), moment(props.date).locale(locale).format('HH:mm')] })), _jsxs("div", __assign({ className: 'title' }, { children: [props.sportName, " - ", props.leagueName, " ", _jsx("br", {}), props.name, " ", props.tv && _jsx("span", { className: 'tv', title: props.tv })] }))] })) })));
    };
    return preMatchHeader;
}(React.Component));
;
preMatchHeader.propTypes = {
    languageId: PropTypes.number.isRequired,
    sportName: PropTypes.string.isRequired,
    sportId: PropTypes.any.isRequired,
    leagueName: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    date: PropTypes.object.isRequired,
    tv: PropTypes.string
};
export default preMatchHeader;



// WEBPACK FOOTER //
// ./src/components/grid/event/preMatchHeader.jsx